<template>
    <div class="contents">
        <div class="info-wrap">
            <div class="info__tit">
                <h3>갑상선암</h3>
                <button class="board-view__btn heart"></button>   
            </div>
            <div class="info__con">
                <div class="info__left" :class="{ 'active': isBbOnTop }">
                    <ul>
                        <li v-for="(item, index) in accordionItems" :key="index"
                            :class="{ 'active': accordionIndex === index }">
                            <a href="javascript:;" @click="activateAccordion(index)">{{ item.title }}</a>
                            <span></span>
                        </li>
                    </ul>
                </div>
                <div class="info__right" ref="con" @scroll="handleScroll">
                    <div class="info__item" v-for="(item, index) in accordionItems" :key="index">
                        <div class="info-text">
                            <h3 class="depth01__title title">{{ item.title }}</h3>
                            <p>{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                isBbOnTop: false,
                accordionItems: [
                    { title: '예시1', content: '예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다.' },
                    { title: '예시2', content: '암에 관한 설명입니다.' },
                    { title: '예시3', content: '예방에 관한 설명입니다.' },
                    { title: '예시4', content: '예방에 관한 설명입니다.' },
                    { title: '예시5', content: '예방에 관한 설명입니다.니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다' },
                    { title: '예시6', content: '예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다.' },
                   
                ],
                accordionIndex: 0,
            };
            
        },
        methods: {
            checkBbPosition() {
                const bbElement = document.querySelector('.info__con');
                if (bbElement) {
                    const bbPosition = bbElement.getBoundingClientRect().top;
                    this.isBbOnTop = bbPosition <= 0;
                }
            },
            handleScroll() {
                const infoItems = document.querySelectorAll('.info__item');
                const infoLeftItems = document.querySelectorAll('.info__left li');

                infoItems.forEach((item, index) => {
                    const rect = item.getBoundingClientRect();
                    const threshold = 2;

                    if (rect.top < threshold && rect.bottom > 0) { // 변경된 부분: 요소의 top이 0보다 작고 bottom이 0보다 큰 경우를 화면 상단에 위치한 것으로 간주합니다.
                        infoLeftItems.forEach((leftItem, leftIndex) => {
                            if (leftIndex === index) {
                                leftItem.classList.add('active');
                            } else {
                                leftItem.classList.remove('active');
                            }
                        });
                    }
                });
            },



            activateAccordion(index) {
                // 엑티브 되는 박스의 index
                const accordionItem = this.$el.querySelectorAll('.info__item')[index];
   
                    
                accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
    
                
                
            }
            
        },
        mounted() {
            window.addEventListener('scroll', this.checkBbPosition);
            window.addEventListener('scroll', this.handleScroll);


            
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.checkBbPosition);
            window.removeEventListener('scroll', this.handleScroll);
        }
    };
</script>